import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import axios from "axios";
import uuid from "uuidv4";
import moment from "moment";
import moment_tz from "moment-timezone";
import Select from "react-select";

import { LoadingIcon, InLineLoading } from "../../Common/Loading_Icon";
import {
  ProfileAddImage,
  ProfileEdit,
  ProfileVerify,
  ProfileSnowman,
} from "../../Common/Buttons/Icons";
import { uploadS3 } from "../../../Helpers/uploadFile";

import { setUserSession } from "../../../Actions/userSessionActions";
import { Trans } from "react-i18next";

class UserInfo extends Component {
  constructor(props) {
    super(props);

    this.uploadImage = this.uploadImage.bind(this);
    this.toggleImageUpload = this.toggleImageUpload.bind(this);
    this.cancelImageUpload = this.cancelImageUpload.bind(this);
    this.updateForm = this.updateForm.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.submitEdit = this.submitEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.submitPhoto = this.submitPhoto.bind(this);
    this.selectOption = this.selectOption.bind(this);

    this.state = {
      edit: false,
      edit_image: false,
      loading_image: false,
      original_profile_form: {
        photo: null,
        first_name: "",
        last_name: "",
        title: "",
        company: "",
        city: "",
        province: "",
        language: "",
        time_zone: "",
        verified: null,
        joined: "",
      },
      profile_form: {
        photo: null,
        first_name: "",
        last_name: "",
        title: "",
        company: "",
        city: "",
        province: "",
        language: "",
        time_zone: "",
      },
      timezones: [],
      provinces: [],
      loading: true,
    };
  }

  componentDidMount() {
    document.title = "Profile Settings - FleetXPress";

    var self = this;
    let url =
      "ajax/profile/" + self.props.userSession.user.profile_id + "/edit";
    axios
      .get(url)
      .then(function(response) {
        var profile_form = {};

        profile_form.first_name = response?.data.view.first_name;
        profile_form.last_name = response?.data.view.last_name;
        profile_form.company = response?.data.view.company;
        profile_form.title = response?.data.view.title;
        profile_form.city = response?.data.view.city;
        profile_form.province = response?.data.view.province;
        profile_form.language = response?.data.view.language;
        profile_form.time_zone = response?.data.view.time_zone;
        profile_form.phone = response?.data.view.phone;
        profile_form.email = response?.data.view.email;
        profile_form.email_confirm = response?.data.view.email;
        profile_form.phone = response?.data.view.phone;
        profile_form.photo = response?.data.view.photo;
        profile_form.verified = response?.data.view.verified;
        profile_form.joined_date = response?.data.view.joined_date;

        var timezones = [];

        for (var i = 0; i < moment_tz.tz.names().length; i++) {
          var timezone = moment_tz.tz.names()[i];
          if (timezone.includes("Canada") && timezone?.split("/").length < 3) {
            timezones.push({
              value: timezone,
              label:
                timezone.replace("_", " ") +
                " (" +
                moment_tz()
                  .tz(timezone)
                  .zoneAbbr() +
                " " +
                moment_tz()
                  .tz(timezone)
                  .format("Z") +
                ")",
              name: "time_zone",
            });
          }
        }

        self.setState({
          loading: false,
          original_profile_form: JSON.parse(JSON.stringify(profile_form)),
          profile_form: JSON.parse(JSON.stringify(profile_form)),
          provinces: response?.data.view.province_options,
          timezones: timezones,
        });
      })
      .catch(function(error) {
        //handle error
        if (error.response?.status == 401) {
          showStatusMsg(error.response?.data.error);
        } else if (error.response?.status == 422) {
          var error_message = "";

          $.each(error.response?.data.errors, function(index, element) {
            error_message += element + "<br />";
          });

          showStatusMsg(error_message);
        } else {
          showStatusMsg("Requested information not found");
        }

        if (self.props.closeModal) self.props.closeModal();
      });
  }

  toggleImageUpload() {
    this.setState({
      edit_image: true,
    });
  }

  cancelImageUpload() {
    var profile_form = this.state.profile_form;
    profile_form.photo = this.state.original_profile_form.photo;

    this.setState({
      edit_image: false,
      profile_form: profile_form,
    });
  }

  uploadImage(id) {
    this.setState({
      loading_image: true,
    });

    var file = document.getElementById(id).files[0];
    var self = this;

    const filename = document
      .getElementById(id)
      .value?.split(/(\\|\/)/g)
      .pop();
    const original_filename = filename?.split(".")[0];
    const extension = filename?.split(".")[1].toLowerCase();
    const unique_id = uuid();

    if (extension !== "jpg" && extension !== "jpeg" && extension !== "png") {
      showStatusMsg(
        "Incorrect filetype for Profile Image. Please upload a .jpg, .jpeg, or .png file",
        "error"
      );
      self.setState({
        loading_image: false,
      });
    } else {
      //Create thumbnail
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var img = new Image();

      canvas.width = 100;
      canvas.height = 100;

      img.onload = function() {
        var scale = Math.min(100 / img.width, 100 / img.height);
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          (100 - img.height * scale) / 2,
          img.width * scale,
          img.height * scale
        );
        canvas.toBlob(function(blob) {
          var profile_form = self.state.profile_form;
          //Upload thumbnail
          uploadS3(
            blob,
            "thumbnail_" + original_filename,
            extension,
            "/profile-images/thumbnails",
            unique_id
          );

          var img2 = new Image();

          canvas.width = 400;
          canvas.height = 400;

          img2.onload = function() {
            var scale = Math.min(400 / img2.width, 400 / img2.height);
            ctx.drawImage(
              img2,
              0,
              0,
              img2.width,
              img2.height,
              0,
              (400 - img2.height * scale) / 2,
              img2.width * scale,
              img2.height * scale
            );
            canvas.toBlob(function(blob) {
              var profile_form = self.state.profile_form;
              //Upload thumbnail
              uploadS3(
                blob,
                original_filename,
                extension,
                "/profile-images",
                unique_id,
                function(response) {
                  profile_form["photo"] = response;

                  self.setState({
                    profile_form: profile_form,
                    loading_image: false,
                  });
                },
                function(error) {
                  self.setState({
                    loading_image: false,
                  });
                }
              );
            });
          };

          img2.src = URL.createObjectURL(file);
        });
      };

      img.src = URL.createObjectURL(file);
    }
  }

  updateForm(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    var profile_form = this.state.profile_form;
    profile_form[name] = value;

    this.setState({
      profile_form: profile_form,
      edit: true,
    });
  }

  toggleEdit() {
    this.setState({
      edit: true,
    });
  }

  submitEdit() {
    //Send request
    var self = this;

    axios({
      method: "post",
      url: "ajax/profile/" + this.props.userSession.user.profile_id + "/update",
      data: this.state.profile_form,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then((response) => {
        //handle success
        if (
          self.props.match &&
          self.props.match.url.split("/")[1] === "administration"
        ) {
          axios({
            method: "post",
            url: "/ajax/users",
            data: {
              search_term: $("#searchbar").val(),
              vmh: $("input[name='vmh[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              sh: $("input[name='sh[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              company: $("input[name='company[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              title: $("input[name='title[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              status: $("input[name='status[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              role: $("input[name='role[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              type: $("input[name='type[]']:checked")
                .map(function() {
                  return this.value;
                })
                .get()
                .join("#"),
              sort_filter: $("#sort_filter").val(),
              sort_direction: $("#sort_direction").val(),
            },
          })
            .then(function(response) {
              self.props.dispatch(
                setList("SET_SHUSER_LIST", response?.data.data.data)
              );
            })
            .catch(function(error) {
              if (!("response" in error)) {
                showStatusMsg("Requested information not found");
              } else if (error.response?.status == 401) {
                showStatusMsg(error.response?.data.error);
              } else if (error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function(index, element) {
                  error_message += element + "<br />";
                });

                showStatusMsg(error_message);
              } else {
                showStatusMsg("Requested information not found");
              }
            });
        }

        showStatusMsg(response?.data.message, "success");
        self.setState({
          edit: false,
          original_profile_form: JSON.parse(
            JSON.stringify(self.state.profile_form)
          ),
        });
      })
      .catch(function(error) {
        if (error.response?.status == 401) {
          showStatusMsg(error.response?.data.error);
        } else if (error.response?.status == 422) {
          var error_message = "";

          $.each(error.response?.data.errors, function(index, element) {
            error_message += element + "<br />";
          });

          showStatusMsg(error_message);
        } else {
          showStatusMsg("Requested information not found");
        }
      });
    //Set to new form
    this.setState({
      original_profile_form: JSON.parse(
        JSON.stringify(this.state.profile_form)
      ),
      edit: false,
    });
  }

  submitPhoto(photo) {
    var self = this;

    axios({
      method: "post",
      url: "ajax/updateimage/" + self.props.userSession.user.profile_id,
      data: {
        photo: photo,
      },
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function(response) {
        showStatusMsg(response?.data.message, "success");

        var profile_form = self.state.profile_form;
        var original_profile_form = self.state.original_profile_form;

        profile_form.photo = response?.data.photo;
        original_profile_form.photo = response?.data.photo;

        self.setState({
          profile_form: profile_form,
          original_profile_form: original_profile_form,
          loading_image: false,
          edit_image: false,
        });

        var user_session = self.props.userSession;
        user_session.user.photo = response?.data.photo;

        //self.props.dispatch(setUserSession(user_session));
      })
      .catch(function(error) {
        if (error.response?.status == 401) {
          showStatusMsg(error.response?.data.error);
        } else if (error.response?.status == 422) {
          var error_message = "";

          $.each(error.response?.data.errors, function(index, element) {
            error_message += element + "<br />";
          });

          showStatusMsg(error_message);
        } else {
          showStatusMsg("Requested information not found");
        }

        self.setState({
          loading_image: false,
        });
      });
  }

  cancelEdit() {
    this.setState({
      profile_form: JSON.parse(
        JSON.stringify(this.state.original_profile_form)
      ),
      edit: false,
    });
  }

  selectOption(e) {
    var profile_form = this.state.profile_form;

    profile_form[e.name] = e.value;

    this.setState({
      profile_form: profile_form,
    });
  }

  render() {
    if (this.state.loading) {
      return <LoadingIcon />;
    }
    return (
      <div className="page_limited">
        <div className="user_info">
          <div className="user_info_upload_container">
            <input
              type="file"
              id="image-upload"
              style={{ display: "none" }}
              onChange={() => this.uploadImage("image-upload")}
              accept=".png,.jpg,.jpeg"
            />
            <div
              className="user_image_container"
              onClick={this.toggleImageUpload}
            >
              {!this.state.profile_form.photo ? (
                <div className="user_image_snowman">{ProfileSnowman()}</div>
              ) : (
                <img
                  src={
                    "https://s3.ca-central-1.amazonaws.com/digitalvms/profile-images/" +
                    this.state.profile_form.photo
                  }
                  className="user_image_profile_settings"
                />
              )}
              {this.state.loading_image ? (
                <div className="user_image_loading">{InLineLoading()}</div>
              ) : null}
              {!this.state.profile_form.photo ? (
                <div className="user_image_add_icon">{ProfileAddImage()}</div>
              ) : (
                <div className="user_image_edit_icon">{ProfileEdit()}</div>
              )}
            </div>
            {this.state.edit_image ? (
              <div className="user_info_edit_image_container">
                <div className="user_info_edit_image_header"><Trans>Edit Image</Trans></div>
                <div className="user_info_edit_image_description">
                 <Trans>
                    Clear frontal face photos provide stakeholders with a good
                    idea of who you are.
                 </Trans>
                </div>
                <div className="user_info_actions">
                  <div
                    className="button secondary px-32 mr-16"
                    onClick={this.cancelImageUpload}
                  >
                    <span className="mr-8 ml-8">Cancel</span>
                  </div>
                  {this.state.original_profile_form.photo ===
                  this.state.profile_form.photo ? (
                    <div
                      className="button primary px-32"
                      onClick={() => $("#image-upload").trigger("click")}
                    >
                      <span className="mr-8 ml-8">Upload Image</span>
                    </div>
                  ) : (
                    <div
                      className="button primary px-32"
                      onClick={() =>
                        this.submitPhoto(this.state.profile_form.photo)
                      }
                    >
                      <span className="mr-8 ml-8"><Trans>Save</Trans></span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="user_info_description">
                <div className="user_info_name_container">
                  <span className="user_info_name">
                    {this.state.original_profile_form.first_name}{" "}
                    {this.state.original_profile_form.last_name}
                  </span>
                  {this.state.original_profile_form.verified ? (
                    <span className="user_info_verified">
                      {ProfileVerify()}
                    </span>
                  ) : null}
                </div>
                {this.state.original_profile_form.title &&
                this.state.original_profile_form.company ? (
                  <span className="user_info_job">
                    {this.state.original_profile_form.title} at{" "}
                    {this.state.original_profile_form.company}
                  </span>
                ) : this.state.original_profile_form.title ? (
                  <span className="user_info_job">
                    {this.state.original_profile_form.title} at{" "}
                    {this.state.original_profile_form.company}
                  </span>
                ) : this.state.original_profile_form.company ? (
                  <span className="user_info_job">
                    {this.state.original_profile_form.company}
                  </span>
                ) : null}
                <span className="user_info_join">
                  <Trans>Joined</Trans>{" "}
                  {moment(this.state.original_profile_form.joined_date).format(
                    "MMMM DD, YYYY"
                  )}
                </span>
              </div>
            )}
          </div>
          <div className="user_info_details">
            <div className="settings_header">
              <div className="left_header"><Trans>Personal Info</Trans></div>
              <div className="right_header">
                {!this.state.edit ? (
                  <div
                    className="button primary px-32"
                    onClick={this.toggleEdit}
                  >
                    <span className="mr-8 ml-8"><Trans>Edit Info</Trans></span>
                  </div>
                ) : (
                  <>
                    <div
                      className="button secondary px-32 mr-16"
                      onClick={this.cancelEdit}
                    >
                      <span className="mr-8 ml-8"><Trans>Cancel</Trans></span>
                    </div>
                    <div
                      className="button primary px-32"
                      onClick={this.submitEdit}
                    >
                      <span className="mr-8 ml-8"><Trans>Save</Trans></span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="user_info_row">
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>First Name</Trans></span>
                <input
                  className="user_info_form_input"
                  name="first_name"
                  value={this.state.profile_form.first_name}
                  onChange={this.updateForm}
                  readOnly={!this.state.edit}
                />
              </div>
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Last Name</Trans></span>
                <input
                  className="user_info_form_input"
                  name="last_name"
                  value={this.state.profile_form.last_name}
                  onChange={this.updateForm}
                  readOnly={!this.state.edit}
                />
              </div>
            </div>
            <div className="user_info_row">
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Role</Trans></span>
                <input
                  className="user_info_form_input"
                  name="title"
                  value={this.state.profile_form.title}
                  onChange={this.updateForm}
                  readOnly={!this.state.edit}
                />
              </div>
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Company</Trans></span>
                <input
                  className="user_info_form_input"
                  name="company"
                  value={this.state.profile_form.company}
                  onChange={this.updateForm}
                  readOnly={!this.state.edit}
                />
              </div>
            </div>
            <div className="user_info_row">
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>City</Trans></span>
                <input
                  className="user_info_form_input"
                  name="city"
                  value={this.state.profile_form.city}
                  onChange={this.updateForm}
                  readOnly={!this.state.edit}
                />
              </div>
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Region</Trans></span>
                <Select
                  options={this.state.provinces.map((province, index) => {
                    return {
                      value: index,
                      label: province[0],
                      name: "province",
                    };
                  })}
                  onChange={this.selectOption}
                  value={{
                    value: this.state.profile_form.province,
                    label: this.state.profile_form.province
                      ? this.state.provinces[
                          this.state.profile_form.province
                        ][0]
                      : null,
                    name: "province",
                  }}
                  placeholder={""}
                  className={"settings_dropdown"}
                  classNamePrefix="react_select"
                  isDisabled={!this.state.edit}
                />
              </div>
            </div>
            <div className="user_info_row">
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Preferred Language</Trans></span>
                <Select
                    options={
                        [{value: "English", label: "English", name: "language"}, {value: "French", label: "French", name: "language"}]
                    } 
                    onChange={this.selectOption}
                    //value={this.state.selectedProvince}
                    value={{value: this.state.profile_form.language, label: this.state.profile_form.language}}
                    className={"settings_dropdown"}
                    classNamePrefix="react_select"
                    isDisabled={! this.state.edit}
                />
              </div>
              <div className="user_info_form_item">
                <span className="user_info_form_label"><Trans>Time Zone</Trans></span>
                <Select
                  options={this.state.timezones}
                  onChange={this.selectOption}
                  value={
                    this.state.profile_form.time_zone
                      ? {
                          value: this.state.profile_form.time_zone,
                          label:
                            this.state.profile_form.time_zone +
                            moment_tz
                              .tz(this.state.profile_form.time_zone)
                              .format(" (z Z)"),
                        }
                      : {}
                  }
                  className={"settings_dropdown"}
                  classNamePrefix="react_select"
                  isDisabled={!this.state.edit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  userSession: store.userSession,
});

export default connect(mapStateToProps)(UserInfo);
